function SetupIosPrompt(){
	
	var alert = $('.ios-prompt');
    var baseurl = alert.attr('data-actionurl');
    var currentLink = alert.attr('data-currentlink');
	
	// on click of the close button
	alert.find('.close').on('click', function(evt){
	
        // animate the panel away
        alert.slideUp();
		
		// tell silverstripe to hide this panel
		$.ajax(	{
				url: baseurl + currentLink,
                type: 'POST',
                data: {},
                response: function(response){
                    // console.log(response);
                }
		});	
	
	});

}

$(document).ready( function() {

    if( $('.ios-prompt').length > 0 ) {

        if (!window.navigator.standalone) {
            SetupIosPrompt();
        } else {
            $('.ios-prompt').remove();
        }
    }
});